import { formatDateForDisplay } from '~/helpers/utils.ts';
import { formatThousandAmount } from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/financialCondition/utils.ts';
import type {
  TIncomeStructureByKvedFormValues,
  TIncomeStructureByKvedIncome,
} from '~/modules/covenants/CovenantsDataApplicationForm/documentGeneration/incomeStructureByKved/types.ts';

export const createIncomeStructureByKvedIncome = (): TIncomeStructureByKvedIncome => ({
  kvedCode: null,
  economicActivityGroup: '',
  incomeAmount: '',
});

export const getIncomeStructureByKvedDefaultValues = (): TIncomeStructureByKvedFormValues => ({
  documentDate: new Date(),
  borrowerFullName: '',
  borrowerIdentifier: '',
  soleProprietor: false,
  reportYear: String(new Date().getFullYear()),
  incomes: [createIncomeStructureByKvedIncome()],
});

export const formatIncomeStructureByKvedDate = (
  value: Date | string | null | undefined
): string => formatDateForDisplay(value);

const getIncomeAmount = (value: string): number => Number(value.replace(',', '.')) || 0;

export const getIncomeStructureByKvedTotal = (
  incomes: TIncomeStructureByKvedIncome[]
): string => formatThousandAmount(incomes.reduce((total, income) => total + getIncomeAmount(income.incomeAmount), 0));
